import rp from 'request-promise-native';
import { defer, Observable } from 'rxjs';
import { Utils } from '../Utils';

/** Return an observable with REST response from the given url */
export const get = (uri: string): Observable<unknown> => {
  return defer(() => {
    const options = {
      uri,
      json: true,
    };
    Utils.attachBearerTokenForDevOnlyRoutes(options);
    return rp(options);
  });
};

export default { get };
